var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.958984H513V342.963H0V0.958984Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 211.919H202.59V342.958H122.674V211.919H0V131.992H122.674V0.954102H202.59V131.992H513V193.329V211.919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 150.583V193.329H184.011V342.958H141.253V193.329H0V150.583H141.253V0.954102H184.011V150.583H513Z",
    fill: "#2E52B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.958008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSj);
export default __webpack_public_path__ + "static/media/SJ.e8492c6026f09a2c1e67c817c40e24d5.svg";
export { ForwardRef as ReactComponent };